export default __webpack_public_path__ + "static/media/example_img_1_4.42247d56.png";